import {EventDispatcher} from 'EventDispatcher';
import {Dictionary} from '../../globals';


enum KeyboardManagerEvents {

}

// https://www.npmjs.com/package/EventDispatcher

export class KeyboardManager {

    public static CTRL_A: string = 'control_a';
    public static DELETE: string = 'delete';
    public static DELETE2: string = 'backspace';

    public static CTRL_LEFT_MOUSE_CLICK: string = 'control_left_mouse_button';
    public static LEFT_ARROW_KEYBOARD_CLICK: string = 'arrowleft';
    public static RIGHT_ARROW_KEYBOARD_CLICK: string = 'arrowright';
    public static TOP_ARROW_KEYBOARD_CLICK: string = 'arrowup';
    public static BOTTOM_ARROW_KEYBOARD_CLICK: string = 'arrowdown';
    public static PRESS_UP_ARROWS: string = 'press_up_arrows'

    private _keyStack: Array<string> = [];
    private _keysTable: Dictionary<boolean> = {}

    private _eventTypes: Array<string> = [];

    private _eventDispatcher: EventDispatcher | null;

    private static _instance: KeyboardManager;

    public static getInstance(): KeyboardManager {
        if (!this._instance) {
            this._instance = new KeyboardManager();
        }

        return this._instance;
    }

    private constructor() {

        this._eventTypes = [
            KeyboardManager.CTRL_A,
            KeyboardManager.DELETE,
            KeyboardManager.DELETE2,
            KeyboardManager.CTRL_LEFT_MOUSE_CLICK,
            KeyboardManager.LEFT_ARROW_KEYBOARD_CLICK,
            KeyboardManager.RIGHT_ARROW_KEYBOARD_CLICK,
            KeyboardManager.TOP_ARROW_KEYBOARD_CLICK,
            KeyboardManager.BOTTOM_ARROW_KEYBOARD_CLICK,
            KeyboardManager.PRESS_UP_ARROWS
        ]
        this._eventDispatcher = new EventDispatcher({validEventTypes: this._eventTypes});

        // window.onkeydown = this.onKeyDown.bind(this);
        // window.onkeyup = this.onKeyUp.bind(this);

        window.addEventListener("keydown", this.onKeyDown.bind(this))
        window.addEventListener("keyup", this.onKeyUp.bind(this))

        window.addEventListener("mousedown", this.onMouseDown.bind(this))
        window.addEventListener("mouseup", this.onMouseUp.bind(this))
    }

    private onMouseDown(event: MouseEvent) {

        switch (event.which) {
            case 1:
                // Left Mouse button
                this.addCharToKeyStack('left_mouse_button')
                break;
        }

        return false;
    }

    private onMouseUp(event: MouseEvent) {

        switch (event.which) {
            case 1:
                // Left Mouse button
                this.removeCharFromKeyStack('left_mouse_button')
                break;
        }

        return false;
    }

    public addEventListener(onEventType: string, callback: (event: any) => void) {
        this._eventDispatcher!.on(onEventType, callback);
    }


    private dispatchEvent(eventType: string) {
        this._eventDispatcher!.trigger(eventType)
    }

    onKeyDown = (event: KeyboardEvent) => {
        const target = event.target as HTMLInputElement
        if (target.nodeName.toLowerCase() !== "input" || (target.type !== 'text' && target.type !== 'number')) {
            if (event.key === 'a' && event.ctrlKey) {
                event.preventDefault();
            }
            if (event.key) {
                let key = event.key.toLowerCase();

                this.addCharToKeyStack(key)
            }
        }
    }

    private addCharToKeyStack(key: string) {
        // to avoid push key down for long time
        // let lastChar = this._keyStack![this._keyStack!.length - 1]
        // if(key !== lastChar){
        //     this._keyStack!.push(key);
        // }

        if (!this._keysTable[key]) {
            this._keyStack!.push(key);
            this._keysTable[key] = true;
        }


        let eventToDispatch = this.getPossibleEVent();
        if (eventToDispatch !== null) {

            this._keysTable = {}
            this._keyStack = [];

            //
            if (eventToDispatch === KeyboardManager.CTRL_LEFT_MOUSE_CLICK) {
                if (key === 'left_mouse_button') {
                    this._keyStack!.push('control');
                    this._keysTable[key] = true;
                }
            }
            if (eventToDispatch === KeyboardManager.DELETE) {
                // if(eventToDispatch === KeyboardManager.DELETE || eventToDispatch === KeyboardManager.DELETE2) {
                this.dispatchEvent(KeyboardManager.DELETE);
            } else {
                this.dispatchEvent(eventToDispatch);
            }


        }
    }

    onKeyUp = (event: KeyboardEvent) => {
        if (event.key && (event.target as HTMLInputElement).nodeName.toLowerCase() !== 'input') {
            let key = event.key.toLowerCase();

            if (
                key === 'arrowleft'
                || key === 'arrowright'
                || key === 'arrowup'
                || key === 'arrowdown'
            ) {
                this.dispatchEvent('press_up_arrows');
            } else {
                this.removeCharFromKeyStack(key)
            }
        }
    }

    removeCharFromKeyStack(key: string) {
        let indexToDelete = this._keyStack!.indexOf(key);
        this._keyStack!.splice(indexToDelete, 1);

        delete this._keysTable[key]

    }

    getPossibleEVent() {
        let keyStack = this._keyStack;
        let eventTypes = this._eventTypes

        let currentStack = this.getCurrentCharsStack();

        let eventToReturn = null;
        for (let i = 0; i < eventTypes.length; i++) {
            const event = eventTypes[i];
            if (event === currentStack) {
                eventToReturn = event;
                break;
            }
        }
        return eventToReturn;
    }

    getCurrentCharsStack() {

        let keyStack = this._keyStack;

        let resultingString = '';

        for (let i = 0; i < keyStack.length; i++) {
            const item = keyStack[i];
            resultingString += item;

            if (i !== keyStack.length - 1) {
                resultingString += '_';
            }
        }

        return resultingString
    }

    dispose() {
        // for (let i = 0; i < this._eventTypes.length; i++) {
        //     const eventType = this._eventTypes[i];
        //     this._eventDispatcher!.off(eventType)
        // }
        this._eventDispatcher!.clear();
    }
}